import React, { useContext, useEffect, useState } from 'react'
import MsgUtils from '../Tools/MsgUtils';
import UtilsBufer from '../Tools/UtilsBufer';
import { ContextGloball } from '../Context/ContextGlobal';
import {Row, Col, Form} from 'react-bootstrap';
const server = process.env.REACT_APP_SERVER;

function CumpleaniosColaborador() {
    const { setLoading } = useContext(ContextGloball);
    const [colaboradores, setColaboradores] = useState([]);
    const [ventana, setVentana] = useState(0);
    const [regional, setRegional] = useState('');
    const [numeroMes, setNumeroMes] = useState(1);

    const getColaboradores = async (mes) => {
        var info = JSON.parse(localStorage.getItem('__react_session__'))
        setRegional(info.regional);
        setLoading(true);

        try {
            var response = await fetch(`${server}/redSocial/cumplesMes`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    'regional': info.regional,
                    'mes': mes,
                })
            });
            if (response.ok) {
                setLoading(false);
                let data = await response.json();
                console.log(data)
                setColaboradores(data.ok);
            } else {
                setLoading(false);
                console.log("No se pudo obtener la ruta")
                MsgUtils.msgError("No se pudo obtener los datos de los colaboradores");
            }
        } catch (networkError) {
            MsgUtils.msgError("No se pudo conectar con la base de datos: " + networkError.message);
        }
    }

    useEffect(() => {
        getColaboradores(numeroMes)
    }, [])

    return (
        <>
            {ventana === 0 && <>
                <div className='container-fluid bg-dark py-2' >
                    <Row>
                        <Col md={2}>
                            <Form.Group>
                                <Form.Label className="text-white m-0">Seleccionar mes</Form.Label>
                                <Form.Select
                                    value={numeroMes}
                                    onChange={(e) => { setNumeroMes(e.target.value); getColaboradores(e.target.value); }}
                                >
                                    <option value="1">Enero</option>
                                    <option value="2">Febrero</option>
                                    <option value="3">Marzo</option>
                                    <option value="4">Abril</option>
                                    <option value="5">Mayo</option>
                                    <option value="6">Junio</option>
                                    <option value="7">Julio</option>
                                    <option value="8">Agosto</option>
                                    <option value="9">Septiembre</option>
                                    <option value="10">Octubre</option>
                                    <option value="11">Noviembre</option>
                                    <option value="12">Diciembre</option>
                                </Form.Select>
                            </Form.Group>
                        </Col>
                    </Row>
                </div>
                <div className='table-responsive'>
                    <table className="table table-dark table-striped table-hover">
                        <thead className='fw-bold'>
                            <tr>
                                <th style={{ width: '320px' }}>Colaborador</th>
                                <th style={{ width: '120px' }}>Sucursal</th>
                                <th style={{ width: '120px' }}>Cumpleaños</th>
                            </tr>
                        </thead>
                        <tbody>
                            {colaboradores.map((item, index) => {
                                return (
                                    <tr key={index}>
                                        <td className='' style={{ minWidth: '300px', maxWidth: '300px' }}>
                                            <div className="card bg-transparent flex-row m-0 p-0" style={{ border: 'none' }} >
                                                {UtilsBufer.getFotoCard(item.FOTO, 40)}
                                                <div className='ps-2 my-auto'>
                                                    <div className="cargoHeader fw-bold" id='buscareAqui'>{item.NOMBREX}</div>
                                                    <div className='cargoHeader '>{item.CARGO}</div>
                                                </div>
                                            </div>
                                        </td>
                                        <td className='my-auto'>{item.SUCURSAL}</td>
                                        <td className='my-auto'>{item.FECHA_NACIMIENTO}</td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                </div>
            </>}
        </>
    )
}

export default CumpleaniosColaborador